export const hotelData = {
  name: "GPHUB Luxury Suites",
  location: "Malakpet, Hyderabad",
  email: "reservations@gphubluxurysuites.com",
  phone: "+91 40 1234 5678",
  whatsapp: "+91 98765 43210",
  address: "Malakpet, Hyderabad, Telangana 500036",
  
  rooms: [
    {
      id: 1,
      title: "Studio Apartment",
      size: "350 sq.ft",
      price: 3500,
      target: "Business Travelers",
      badge: "Budget",
      image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=800&q=80",
      features: ["King Bed", "High-speed WiFi", "Breakfast Included", "Rain Shower"]
    },
    {
      id: 2,
      title: "2BHK Apartment",
      size: "850 sq.ft",
      price: 4000,
      target: "Families",
      badge: "Family",
      image: "https://images.unsplash.com/photo-1566665797739-1674de7a421a?auto=format&fit=crop&w=800&q=80",
      features: ["2 Bedrooms", "Free WiFi", "Kitchenette", "Garden View"]
    },
    {
      id: 3,
      title: "Premium Suite",
      size: "1100 sq.ft",
      price: 5000,
      target: "Luxury Seekers",
      badge: "Luxury",
      image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800&q=80",
      features: ["Grand Suite", "Premium WiFi", "Buffet Breakfast", "Private Balcony"]
    },
    {
      id: 4,
      title: "Executive Suite",
      size: "1200 sq.ft",
      price: 6000,
      target: "VIP Guests",
      badge: "VIP",
      image: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=800&q=80",
      features: ["VIP Lounge Access", "Ultra WiFi", "Personal Butler", "Jacuzzi Bath"]
    }
  ],
  
  amenities: [
    { 
      name: "Free WiFi", 
      icon: "Wifi",
      image: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?auto=format&fit=crop&w=800&q=80"
    },
    { 
      name: "24/7 Security", 
      icon: "ShieldCheck",
      image: "https://images.unsplash.com/photo-1582885918712-421f2dcb6743?auto=format&fit=crop&w=800&q=80"
    },
    { 
      name: "Room Service", 
      icon: "Utensils",
      image: "https://images.unsplash.com/photo-1541614101331-1a5a3a194e92?auto=format&fit=crop&w=800&q=80"
    },
    { 
      name: "Housekeeping", 
      icon: "Wind",
      image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=800&q=80"
    },
    { 
      name: "Private Parking", 
      icon: "CarFront",
      image: "https://images.unsplash.com/photo-1506521781263-d8422e82f27a?auto=format&fit=crop&w=800&q=80"
    },
    { 
      name: "Power Backup", 
      icon: "Zap",
      image: "https://images.unsplash.com/photo-1493612276216-ee3925520721?auto=format&fit=crop&w=800&q=80"
    }
  ],
  
  experiences: [
    {
      title: "Birthday Parties",
      description: "Celebrate your special day in our grand banquet halls with bespoke decor.",
      image: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=800&q=80",
      packages: ["Basic", "Premium", "Luxury"]
    },
    {
      title: "Corporate Meetings",
      description: "State-of-the-art conference rooms for your elite business discussions.",
      image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&w=800&q=80",
      packages: ["Standard", "Executive", "Boardroom"]
    },
    {
      title: "Friends and Family Gatherings",
      description: "Spacious areas designed for intimate and large family reunions.",
      image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=800&q=80",
      packages: ["Silver", "Gold", "Diamond"]
    }
  ],
  
  offers: [
    {
      title: "Weekend Getaway",
      discount: "Flat 20% Off",
      badge: "HOT",
      image: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=600&q=80"
    },
    {
      title: "Early Bird Offer",
      discount: "15% Off on 30+ Days Advance",
      badge: "LIMITED",
      image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?auto=format&fit=crop&w=600&q=80"
    }
  ],
  
  testimonials: [
    {
      name: "Rahul Sharma",
      rating: 5,
      feedback: "The hospitality was exceptional. The Executive Suite truly felt like VIP treatment. Highly recommended!"
    },
    {
      name: "Priya Varma",
      rating: 5,
      feedback: "Beautiful rooms and great location in Hyderabad. The staff went above and beyond to make our stay comfortable."
    },
    {
      name: "John Doe",
      rating: 4,
      feedback: "Elegant design and very clean. Perfect for business travelers who want a bit of luxury."
    }
  ],
  
  gallery: [
    "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1566665797739-1674de7a421a?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?auto=format&fit=crop&w=800&q=80"
  ]
};
